import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import GlobalStyle from './styles/global';

import AppProvider from './hooks';

import Routes from './routes';
import MaintenanceChecker from './components/MaintenanceChecker';

const App: React.FC = () => {
  if (window.location.href === process.env.REACT_APP_REDIRECT_URL) {
    window.location.href = '/';
  }
  return (
    <>
      <BrowserRouter>
        <AppProvider>
          <MaintenanceChecker />
          <Routes />
        </AppProvider>
      </BrowserRouter>
      <GlobalStyle />
    </>
  );
};

export default App;
